import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home'
import FicheHoraire from '../components/FicheHoraire'
import DetailBus from '../components/DetailCarte'
import DetailCarteTAD from '../components/DetailCarteTAD'
import VueMatomo from 'vue-matomo'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/:stopName',
      name: 'Home',
      component: Home
    },
    {
      path: '/fiche-horaire',
      name: 'fichehoraire',
      component: FicheHoraire
    },
    {
      path: '/carte/:tripId/:stopId/:sequence',
      name: 'detailBus',
      component: DetailBus
    },
    {
      path: '/carteTAD/:courseTadId/:reservationId',
      name: 'detailBusTAD',
      component: DetailCarteTAD
    }
  ]
})

Vue.use(VueMatomo, {
  host: 'https://pretapartir.matomo.cloud/',
  siteId: 10,
  trackerFileName: 'matomo',
  enableLinkTracking: true,
  trackInitialView: true,
  trackPageView: true,
  router: router,
  debug: false,
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js